import { ButtonHTMLAttributes, ReactNode } from 'react';

// The system-wide round toolbar icon button: 24px, primary outline, tooltip
// carries the label (list-toolbar convention — toolbar actions are icon-only).
// One definition; TableToolbar, Statements, Reports and the projects grid
// toolbars all render THIS instead of re-declaring the class string.
type IconButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'title' | 'aria-label' | 'children'> & {
  label: string;        // tooltip + aria-label
  children: ReactNode;  // the icon, size 13-14
};

export function IconButton({ label, className = '', children, ...rest }: IconButtonProps) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center h-[24px] w-[24px] rounded-full text-primary border border-primary/40 hover:bg-primary/10 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary disabled:opacity-45 disabled:pointer-events-none ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
